/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface VoucherSubscriberBilling {
  amount?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  editionId?: number;
  number?: string;
  paymentMethod?: number;
  secondaryId?: string;
  subscriberBillingId?: number;
  subscriberBillingStatus?: string;
  subscriberBillingStatusId?: number;
  subscriberId?: number;
  subscriptionTypeName?: string;
  voucherId?: number;
  voucherProviderId?: number;
  voucherProviderName?: string;
}
